import { render, staticRenderFns } from "./DialogSizeLimit.vue?vue&type=template&id=582856c8&"
import script from "./DialogSizeLimit.vue?vue&type=script&lang=js&"
export * from "./DialogSizeLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports